import {
  createReducer,
  updateObject,
  updateItemInArray,
} from 'helpers/ReducerUtil'
import {
  ADD_CONNECTOR,
  REMOVE_CONNECTOR,
  UPDATE_CONNECTOR_TYPE_VALUE,
  UPDATE_CONNECTOR_COUNT_VALUE,
} from './constants'

const updateConnectorTypeValue = (values, action) => {
  const { index, pinCount } = action
  return updateItemInArray(values, index, value => (
    updateObject(value, { pinCount })
  ))
}

const updateConnectorCountValue = (values, action) => {
  const { index, connectorCount } = action
  return updateItemInArray(values, index, value => (
    updateObject(value, { connectorCount })
  ))
}

const addConnector = (values, action) => [...values, {pinCount: '', connectorCount: ''} ]
const removeConnector = (values, action) => values.filter((val, index) => index !== action.index)

const inputConnectorReducer = createReducer([], {
  [UPDATE_CONNECTOR_TYPE_VALUE]: updateConnectorTypeValue,
  [UPDATE_CONNECTOR_COUNT_VALUE]: updateConnectorCountValue,
  [ADD_CONNECTOR]: addConnector,
  [REMOVE_CONNECTOR]: removeConnector,
})

export default inputConnectorReducer
